import { colorSystemConfigurationsApi } from '../api/colorSystemConfigurations.api';
import { useDataTable } from '../../../hooks/useDataTable';
export const useColorsSystemConfigurations = () => {
  const table = useDataTable(colorSystemConfigurationsApi);
  return {
    ...table,
  };
};
